import React, { createContext, useEffect, useReducer, useState } from 'react';

// third-party
import { CognitoUser, CognitoUserPool, CognitoUserSession, CognitoUserAttribute, AuthenticationDetails, ChallengeName } from 'amazon-cognito-identity-js';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// project imports
import Loader from 'ui-component/Loader';
import { AWS_API_BS } from 'config';
import { AWSCognitoContextType, InitialLoginContextProps } from 'types/auth';
import { FeatureFlags } from 'types/user-profile';
import { AuthApi } from 'back_app';

import { useNavigate } from 'react-router-dom';

// constant
const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
   
    user: null
};



export const userPool = new CognitoUserPool({
    UserPoolId: AWS_API_BS.poolId || '',
    ClientId: AWS_API_BS.appClientId || ''
});

const setSession = (serviceToken?: string | null) => {
    if (serviceToken) {
        localStorage.setItem('serviceToken', serviceToken);
    } else {
        localStorage.removeItem('serviceToken');
    }
};
const setLocalTokenSession = (serviceLocalToken?: string | null) => {
    if (serviceLocalToken) {
        localStorage.setItem('serviceLocalToken', serviceLocalToken);
    } else {
        localStorage.removeItem('serviceLocalToken');
    }
};

const setUserSession = (serviceUser?: string | null) => {
    if (serviceUser) {
        localStorage.setItem('bs-mm-userAuth', serviceUser);
    } else {
        localStorage.removeItem('bs-mm-userAuth');
    }
};

// ==============================|| AWS Cognito CONTEXT & PROVIDER ||============================== //
const AWSCognitoContext = createContext<AWSCognitoContextType | null>(null);

export const AWSCognitoProvider = ({ children }: { children: React.ReactElement }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);
    const [isAuthenticated,setIsAuthenticated]=useState<boolean|null>(false);
    const [SavedCognitoUser, setCognitoUser] = useState<CognitoUser | null>(null);
    const [mfaRequired, setMfaRequired] = useState(false);
    const[secret,SetSecret]=useState("");
    const[mail,setMail]=useState("");
    const [totpCodeError, setTotpCodeError] = useState("");
// const [open, setOpen] = useState(false);
   const[isMfa,setIsMfa]=useState(true);
 const navigate = useNavigate();
    useEffect(() => {
        const init = async () => {
            try {
                console.log('init auth');
                 if(isAuthenticated==true){
                    setIsAuthenticated(false);
                 }               // const loggedInUser = userPool.getCurrentUser();
               // console.log('loggedInUser',loggedInUser);
                const serviceToken = window.localStorage.getItem('serviceToken');
                const serviceLocalToken = window.localStorage.getItem('serviceLocalToken');

                if (serviceToken && serviceLocalToken) {
                    let temp_user = null;
                    setSession(serviceToken);
                    setLocalTokenSession(serviceLocalToken);
                    if(!state.user){
                        const userAuth = window.localStorage.getItem('bs-mm-userAuth');
                        
                        if(userAuth){
                            temp_user = JSON.parse(userAuth);
                        }
                    } else{
                        temp_user = state.user;
                    }
                    dispatch({
                        type: LOGIN,
                        payload: {
                            isLoggedIn: true,
                            isMfa,
                            user: temp_user,

                            // permissions: {
                            //     IsAdmin: false,
                            //     GeneralSettings: false,
                            //     AccountsCD: false,
                            //     OperationalReports: false,
                            //     ManagementReports: false,
                            //     ClientZone: false
                            // }
                        }
                    });
                } else {
                    dispatch({
                        type: LOGOUT
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: LOGOUT
                });
            }
        };

        init();
    }, []);

    const login = async (email: string, password: string, failCallback?: (err_message: string) => void) => {
        setMail(email);
        const cognitoUser = new CognitoUser({
            Username: email,
            Pool: userPool
        });

        const authData = new AuthenticationDetails({
            Username: email,
            Password: password
        });



        cognitoUser.authenticateUser(authData, {
            onSuccess: (cognitoUserSession: CognitoUserSession) => {
                  setCognitoUser(cognitoUser); 
                     cognitoUser.getUserData((e, _data) => {
                                    if (e) {
                                        console.error("Error fetching user data", e);
                                        return;
                                    }

                                    const hasMfa = _data?.UserMFASettingList?.includes("SOFTWARE_TOKEN_MFA");
                                    if (hasMfa!= undefined && hasMfa == true) {

                                        setIsMfa(true);
                                        // navigate(`/user/account-profile/profile2`);
                                    } 
                                    else{
                                         setIsMfa(true);

                                    }
                                    });
                  
                  logInByAws(cognitoUserSession,authData,failCallback);
           
       
            },
            onFailure: (_err) => {
             
                // console.error('Error during LogInByAws ErrorMessage:', _err);
                failCallback && failCallback(_err.message);
                // throw new Error('Error during LogInByAws');
            },
         
      selectMFAType:()=>{
                    cognitoUser.sendMFASelectionAnswer('SOFTWARE_TOKEN_MFA', {
                onSuccess: (session) => {
                  
                console.log("✅ MFA type selected and login complete:", session);
                },
                onFailure: (err) => {
                console.error("❌ Error selecting MFA type:", err);
                },
                
                totpRequired:(challengeParameters?: any) => {
                  console.log("totpRequired:", challengeParameters);
                 setCognitoUser(cognitoUser);
                 setMfaRequired(true);
                   setIsAuthenticated(true);
                    cognitoUser.getUserData((e, _data) => {
                                    if (e) {
                                        console.error("Error fetching user data", e);
                                        return;
                                    }

                                    const hasMfa = _data?.UserMFASettingList?.includes("SOFTWARE_TOKEN_MFA");
                                    if (hasMfa!= undefined && hasMfa == true) {

                                        setIsMfa(true);
                                        // navigate(`/user/account-profile/profile2`);
                                    } 
                                    else{
                                         setIsMfa(false);

                                    }
                                    });
                   cognitoUser.associateSoftwareToken({
      associateSecretCode: (secretCode) => {
        console.log("Secret code:", secretCode);
        setMfaRequired(true);
        SetSecret(secretCode);
      },
      onFailure: (err) => console.error("❌ associateSoftwareToken error:", err),
    });
                    }
                });
            },

    mfaSetup: () => {
    // Step 1: Associate software token
    cognitoUser.associateSoftwareToken({
      associateSecretCode: (secretCode) => {
        console.log("Secret code for Authenticator:", secretCode);
  setCognitoUser(cognitoUser);
                 setMfaRequired(true);
                   setIsAuthenticated(true);
                   
      
         const code = prompt("Enter 6-digit code from your Authenticator app:");

        // Step 3: Verify software token
        if (code) {
            
        cognitoUser.verifySoftwareToken(code, "My TOTP Device", {
          onSuccess: () => {
            console.log("✅ Software token verified");

            // Step 4: Enable software token MFA
            cognitoUser.setUserMfaPreference(
              null, // SMS MFA not used
              { PreferredMfa: true,Enabled:true }, // TOTP MFA preferred
              (err, result) => {
                if (err) console.error("❌ Failed to set MFA preference", err);
                else console.log("✅ MFA setup complete!", result);
              }
            );
          },
          onFailure: (err) => console.error("❌ verifySoftwareToken failed", err),
        });
    }
      },
      onFailure: (err) => console.error("❌ associateSoftwareToken failed", err),
    });

  },
   
        totpRequired: (challengeParameters?: any) => {
        
        setCognitoUser(cognitoUser);
        setIsAuthenticated(true);
         setMfaRequired(false);
       
    
      },
            newPasswordRequired: (userAttributes, requiredAttributes) => {
                console.log('newPasswordRequired');
                // // User was signed up by an admin and must provide new
                // // password and required attributes, if any, to complete
                // // authentication.
                // // the api doesn't accept this field back
                // delete userAttributes.email_verified;
                // // unsure about this field, but I don't send this back
                // delete userAttributes.phone_number_verified;
                // // Get these details and call
                cognitoUser.completeNewPasswordChallenge(password,requiredAttributes,{
                    onSuccess: (cognitoUserSession:CognitoUserSession) => {
                      
                      console.log('Password changed successfully!');
                      // User is now authenticated, you can proceed
                      logInByAws(cognitoUserSession,authData,failCallback);
                    },
                    onFailure: (err) => {
                        debugger;
                      console.error('Failed to change password:', err);
                      // Handle errors here (e.g. weak password)
                    }
                  });
                 // usr.completeNewPasswordChallenge(password, userAttributes, requiredAttributes);
            }
        });
    };
 const handleVerifyMfa = (_SavedCognitoUser:any,totpCode:string,email:string) => {
  //  new Promise((success, rej) => {
     if (!_SavedCognitoUser) { 
       // rej(new Error('no cognito user'))
        return; 
    }
    setTotpCodeError('')
     _SavedCognitoUser.sendMFACode
     (totpCode, 
         {
       onSuccess: (session:any) => {
         console.log("✅ MFA complete:", session);
       
          const authData = new AuthenticationDetails({
                     Username: email,
                     Password: ''
                 });
            
              logInByAws(session,authData,(err:any)=>{
                setTotpCodeError(`Login failed: ${err.message || JSON.stringify(err)}`);
                console.error("❌Login failed:", err);
              });
        // success(true);
       },
       onFailure: (err:any) => {
         setTotpCodeError(`MFA failed: ${err.message || JSON.stringify(err)}`);
         console.error("❌ MFA failed:", err);
       // rej(err);
       },
 
        },    
       'SOFTWARE_TOKEN_MFA',);
    }
//   });
    const logInByAws = (cognitoUserSession: CognitoUserSession,authData: AuthenticationDetails,failCallback?: (err_message: string) => void) => {
        // responseData: the C# LogInByAws UserCls
        const login_set = (responseData: any) => {
            setSession(cognitoUserSession.getAccessToken().getJwtToken());
            setLocalTokenSession(responseData.Token);
            const temp_user =  {
                email: authData.getUsername(),
                name: responseData.Name,
                role: responseData.RoleId,
                isSystemAdmin:responseData.IsSystemAdmin,
                isDeveloper:responseData.IsDeveloper,
                permissions:responseData.Permissions,
                company: responseData.Company.Name,
                logo: responseData.Company.Logo,
                features: responseData.Features ? responseData.Features.split(',') : []
            };
            dispatch({
                type: LOGIN,
                payload: {
                    isLoggedIn: true,
                    isMfa,
                    user:temp_user
                }
            });
            setUserSession(JSON.stringify(temp_user));
        };
        const login_fail = (error: any) => {
            failCallback && failCallback(error.message);
            console.error('Error during LogInByAws:', error);
            logout();
        };
        AuthApi.logInByAws(cognitoUserSession.getAccessToken().getJwtToken(),
            authData.getUsername()).then(login_set).catch(login_fail);
    };
    // the logged in user's features once saved (its user's Special
    // Features): menus and buttons follow without a new login
    let user_features_set = (features: FeatureFlags[]) => {
        if (!state.user)
            return;
        let temp_user = {...state.user, features};
        dispatch({type: LOGIN, payload: {isLoggedIn: true, isMfa,
            user: temp_user}});
        setUserSession(JSON.stringify(temp_user));
    };
    const resendVerification = (email: string) =>
        new Promise((success, rej) => {
            const cognitoUser = new CognitoUser({
                Username: email,
                Pool: userPool
            });
            cognitoUser.resendConfirmationCode((err, result) => {
                if (err) {
                    rej(err);
                } else {
                    success(result);
                }
              });
        });
        const register = (email: string, password: string, fullName: string) =>
        new Promise((success, rej) => {
            userPool.signUp(
                email,
                password,
                [new CognitoUserAttribute({ Name: 'email', Value: email }), new CognitoUserAttribute({ Name: 'name', Value: fullName })],
                [],
                async (err, result) => {
                    if (err) {
                        rej(err);
                        return;
                    }
                    success(result);
                }
            );
        });

    const logout = () => {
        const loggedInUser = userPool.getCurrentUser();
        setUserSession(null);
        setIsAuthenticated(false);
        setMfaRequired(false);
        SetSecret("");
        
        if (loggedInUser) {
            setSession(null);
            setLocalTokenSession(null);
           

            loggedInUser.signOut();
            dispatch({ type: LOGOUT });
        }
    };

    const changePassword = (old_password:string,new_password:string) => 
        new Promise((resolve, rej) => { 

            const cognitoUser = userPool.getCurrentUser();

            if (cognitoUser) {
              cognitoUser.getSession((error: Error, session:any) => {
                if (error || !session.isValid()) {
                  console.error("Session is invalid", error);
                  resolve(error.message || "Session is invalid");
                  return;
                }
            
                // Call changePassword only after confirming valid session
                cognitoUser.changePassword(old_password, new_password, (err, result) => {
                  if (err) {
                    console.error("Change password failed", err);
                    return;
                  }
                  console.log("Password changed successfully", result);
                  resolve(true);
                });
              });
            } else {
              console.error("No user is currently signed in");
              resolve("No user is currently signed in");
            }
    
        });

    const sendResetPasswordVerificationCode = (email:string) => 
    new Promise((resolve, rej) => { 
        const cognitoUser = new CognitoUser({
            Username: email,
            Pool: userPool
        });
                        
            cognitoUser.forgotPassword({
            onSuccess: (data) => {
                resolve(1);
                console.log('Password reset initiated successfully:', data);
            },
            onFailure: (err) => {
                resolve(false);
                console.error('Error initiating password reset:', err);
            },
            inputVerificationCode: () => {
                resolve(2);
                console.log('Verification code sent. Prompt user to enter it.');
            },
            });
    });
 
    
    const changePasswordWithVerificationCode = (email:string,verificationCode:string,new_password:string) => 
    new Promise((resolve, rej) => { 
        const cognitoUser = new CognitoUser({
            Username: email,
            Pool: userPool
        });
                        
        cognitoUser.confirmPassword(verificationCode, new_password, {
            onSuccess: () => {
                console.log('Password reset successfully');
                resolve(true);
            },
            onFailure: (err) => {
                console.error('Error resetting password:', err);
                resolve(err.message);
            },
            });
            
    });
        
        

    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    return <AWSCognitoContext.Provider value={{ ...state, 
        login, 
        logout, 
        register,
        changePassword,
        sendResetPasswordVerificationCode,
        changePasswordWithVerificationCode,
        resendVerification,
        isAuthenticated,
        SavedCognitoUser,
        logInByAws,
        user_features_set,
        mfaRequired,
        secret,
        handleVerifyMfa,
        isMfa,
        totpCodeError}}>{children}</AWSCognitoContext.Provider>;
};

export default AWSCognitoContext;
